import { useNavigate, useRouteContext, useSearch } from "@tanstack/react-router";
import { authClient, queryClient } from "../api.ts";
import { Barras, Logo } from "../componentes/Barras.tsx";
import { ActivarSegundoFactor, VerificarSegundoFactor } from "../componentes/SegundoFactor.tsx";

/**
 * La puerta de la fase 6 al entrar desde fuera de la red: con sesión abierta, pero sin que la
 * API entregue nada hasta que esta sesión dé el código. Si la persona todavía no tiene
 * aplicación de autenticación, primero la activa aquí mismo. Sin sidebar, como el login.
 */
export function PaginaSegundoFactor() {
  const { perfil } = useRouteContext({ from: "/segundo-factor" });
  const navigate = useNavigate();
  const search = useSearch({ from: "/segundo-factor" });
  const sinActivar = perfil.segundoFactor.estado === "sin_activar";

  function seguir() {
    // La sesión ya dio el código: todo lo que estaba en caché se pidió sin él.
    queryClient.clear();
    navigate({ to: search.volverA && search.volverA !== "/login" ? search.volverA : "/" });
  }

  async function salir() {
    await authClient.signOut();
    queryClient.clear();
    navigate({ to: "/login" });
  }

  return (
    <div className="grid min-h-screen place-items-center bg-marino-profundo p-6">
      <div className="w-full max-w-[480px]">
        <div className="mb-5 flex justify-center">
          <Logo variante="blanco" alto={48} />
        </div>
        <div className="rounded-lamina bg-white p-8 shadow-[0_30px_60px_rgba(0,0,0,.35)]">
          <div className="mb-5">
            <div className="mb-2 text-rojo-marca">
              <Barras alto={12} />
            </div>
            <h1 className="text-[20px] font-bold text-marino">
              {sinActivar ? "Activa el segundo factor" : "Código de verificación"}
            </h1>
            <p className="mt-1 text-[12.5px] text-texto-3">
              {sinActivar
                ? "Estás entrando desde fuera de la red. Para continuar tienes que activar una aplicación de autenticación en tu celular; es una sola vez."
                : `Hola, ${perfil.usuario.nombre.split(" ")[0]}. Estás entrando desde fuera de la red: escribe el código de tu aplicación de autenticación.`}
            </p>
          </div>

          {sinActivar ? (
            <ActivarSegundoFactor onActivado={seguir} />
          ) : (
            <VerificarSegundoFactor onVerificado={seguir} />
          )}

          <div className="mt-6 flex items-center justify-between text-[11.5px] text-texto-3">
            <span>Dentro de la oficina no se pide.</span>
            <button type="button" onClick={salir} className="underline-offset-2 hover:underline">
              Cerrar sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
